// extracted by mini-css-extract-plugin
export default {"row":"editGame_row__7z0Dz","col":"editGame_col__rkNLu","card":"editGame_card__FsvK5"};